import React, {useRef, useState} from 'react';
import Select from 'react-select';
import './FormContactsExtended.scss';
import './FormContactsExtended-media.scss';
import Input from '../Input/Input';
import InputPhone from '../Input/InputPhone';
import Button from '../Button/Button';
import {ServiceData} from '../../redux/services/ServiceRedux';
import {connect, WithStore, MapStateToProps, MapDispatchToProps} from '../../redux/services/Imports';
import ErrorText from '../ErrorText/ErrorText';
import {ISelectItem} from '../SelectsCity/interfaces';
import {Departments} from './constants';
import {ValidationFormContacts} from './function';
import Textarea from '../Textarea/Textarea';
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {Props} from './interfaces';
import {CSSTransition} from 'react-transition-group';
import SuccessContent from '../SuccessContent/SuccessContent';
import {content} from "../../services/content";
import AgreementCheckboxes from "../AgreementCheckboxes/AgreementCheckboxes"; // Added import
import ErrorTextBlocked from "../ErrorTextBlocked/ErrorTextBlocked"; // Added import

declare const ym: any;
declare const _tmr: any;

const FormContactsExtended = ({
                                blockedSend, blockedSendLoaded, eventMetrika, recaptchaV2ref,
                                title = content.formContacts.title,
                                buttonText = content.formContacts.button,
                                contactForms
                              }: Props) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('+7');
  const [email, setEmail] = useState('');
  const [department, setDepartment] = useState<ISelectItem>(Departments[0]);
  const [orderNumber, setOrderNumber] = useState('');
  const [msg, setMsg] = useState('');

  const [successShow, setSuccessShow] = useState(false);
  const [errorPhone, setErrorPhone] = useState<string | null>(null);
  const [errorEmail, setErrorEmail] = useState<string | null>(null);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const showEmail = !!contactForms?.show_email;

  const [serverText, setServerText] = useState<string | null>(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);

  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
  const [allowMarketing, setAllowMarketing] = useState(true);
  const [privacyErrorCount, setPrivacyErrorCount] = useState(0);

  const success = () => {
    setName('');
    setPhone('+7');
    setEmail('');
    setDepartment(Departments[0]);
    setOrderNumber('');
    setMsg('');
    setSuccessShow(true);
    if (typeof ym !== 'undefined') {
      ym(26501373, 'reachGoal', 'feedback_success');
    }
    if (typeof _tmr !== 'undefined') {
      _tmr.push({ type: 'reachGoal', id: 3737442, goal: 'vkamolead'});
    }
    setTimeout(() => setSuccessShow(false), 3000); // Keep or remove based on desired behavior
    setDisableBtn(false);
    setPrivacyPolicyAccepted(false);
    setAllowMarketing(true);
    setPrivacyErrorCount(0);
    setErrorPhone(null);
    setErrorMsg(null);
    setServerText(null);
  };

  const {executeRecaptcha} = useGoogleReCaptcha(); // v3

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();

    if (!privacyPolicyAccepted) {
      setPrivacyErrorCount(c => c + 1);
      return;
    }

    setDisableBtn(true);
    setErrorPhone(null);
    setErrorEmail(null);
    setErrorMsg(null);
    setServerText(null);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    // v3
    let token = '';
    if (!executeRecaptcha) {
      console.debug('recaptcha not set, ignoring');
    } else {
      token = await executeRecaptcha(); // v3
    }

    if (!ValidationFormContacts({phone, msg, setErrorPhone, setErrorMsg, email, setErrorEmail, requireEmail: showEmail})) {
      setDisableBtn(false);
      return;
    }
    ServiceData.sendEmailContacts({
      data: {
        name,
        phone,
        department: department.value,
        orderNumber,
        msg,
        allowMarketing, // Add marketing consent
        ...(showEmail ? { email } : {}),
      },
      token,
      setServerText,
      success,
      blockedSendLoaded,
      eventMetrika,
      contactFormId: contactForms.new_contact_form_id // Ensure this ID is correct
    });
  };

  const nodeRefSuccess = useRef(null);
  const nodeRef = useRef(null);

  return (
    <div className="form-contacts-extended">
      <CSSTransition
        in={successShow}
        nodeRef={nodeRefSuccess}
        timeout={{appear: 200, enter: 0, exit: 200}}
        classNames="css-transition-modal"
        unmountOnExit
      >
        <SuccessContent refCss={nodeRefSuccess}/>
      </CSSTransition>

      <CSSTransition
        in={!successShow}
        nodeRef={nodeRef}
        timeout={{appear: 200, enter: 0, exit: 0}}
        classNames="css-transition-content"
        unmountOnExit
      >
        <div className="form-contacts-extended__block">
          <h2 className="form-contacts-extended__title">{title}</h2>

          <form className="form-contacts-extended__form" onSubmit={handleReCaptchaVerify}>
            <Input label={content.formContacts.inputName} name="name" value={name}
                   onChange={(e: any) => setName(e.target.value)}/>
            <InputPhone
              label={content.formContacts.inputPhone}
              name="phone"
              value={phone}
              onChange={(e: any) => {
                setPhone(e.target.value);
                if (errorPhone) setErrorPhone(null);
                if (serverText) setServerText(null);
              }}
              error={errorPhone}
            />
            {showEmail && (
              <Input
                type="email"
                label={content.formContacts.inputEmail}
                name="your-email"
                value={email}
                onChange={(e: any) => {
                  setEmail(e.target.value);
                  if (errorEmail) setErrorEmail(null);
                  if (serverText) setServerText(null);
                }}
                error={errorEmail}
              />
            )}

            <div>
              <p className="input__label">{content.formContacts.inputDepartment}</p>
              <Select
                options={Departments}
                placeholder={''}
                isSearchable={false}
                className="select-input__item"
                classNamePrefix="select-input"
                onChange={(selectedOpt: any) => setDepartment(selectedOpt)}
                value={department}
              />
            </div>

            <Input
              label={content.formContacts.inputOrderNr}
              name="orderNumber"
              value={orderNumber}
              onChange={(e: any) => setOrderNumber(e.target.value)}
            />

            <Textarea
              label={content.formContacts.inputMessage}
              value={msg}
              onChange={(e: any) => {
                setMsg(e.target.value);
                if (errorMsg) setErrorMsg(null);
                if (serverText) setServerText(null);
              }}
              error={errorMsg}
            />

            {showBlockedError && blockedSend.state && (
              <div className="form-contacts-extended__error-blocked">
                <ErrorTextBlocked counter={blockedSend.counter} />
              </div>
            )}

            <AgreementCheckboxes
              privacyChecked={privacyPolicyAccepted}
              onPrivacyChange={(checked) => {
                setPrivacyPolicyAccepted(checked);
                if (checked) setPrivacyErrorCount(0);
              }}
              marketingChecked={allowMarketing}
              onMarketingChange={setAllowMarketing}
              errorTrigger={privacyErrorCount}
            />

            <div className="form-contacts-extended__button">
              {serverText && !errorPhone && !errorMsg ? ErrorText(serverText, true) : null}
              <Button
                text={buttonText}
                size="M"
                widthAll
                disabled={disableBtn}
                showBlockedError={showBlockedError}
              />
            </div>
          </form>
        </div>
      </CSSTransition>
    </div>
  );
};

// Custom mergeProps to let ownProps override stateProps (fixes contactForms being overwritten by Redux defaults)
const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

export default WithStore()(connect(MapStateToProps, MapDispatchToProps, mergeProps)(FormContactsExtended));
